import { useState } from 'react';
import './chat.css';

const BADGE_PHOTO_URL = 'https://badgephotos.corp.amazon.com/?uid=';

// Round badge photo for an Amazon alias. Hides itself if the photo
// fails to load (no Midway session, unknown alias, ...).
export default function BadgePhoto({ alias, size = 24 }: { alias: string; size?: number }) {
  const [failed, setFailed] = useState(false);
  if (!alias || failed) return null;
  return (
    <img
      className="chat-avatar"
      style={{ width: size, height: size }}
      src={BADGE_PHOTO_URL + encodeURIComponent(alias)}
      alt=""
      title={alias}
      onError={() => setFailed(true)}
    />
  );
}
